export const TEST_ID = {
  ORDER_SUMMARY_TITLE: 'order-summary-title',
};
